import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { AdminService } from '../admin.service';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { DepartmentModel } from 'src/app/core/models/DepartmentModel';
import { User } from 'src/app/core/models/user';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DeactivateTypeEnum } from 'src/app/core/models/DeactivateTypeEnum';
import { Constants } from 'src/app/constants/constants';
import { ViewValidationsComponent } from '../view-validations/view-validations.component';

@Component({
  selector: 'app-department',
  standalone: false,
  templateUrl: './department.component.html',
  styleUrl: './department.component.less'
})
export class DepartmentComponent {
  exportData: any[] = [];
  searchText: string = "";

  sortingSubDeptName: string = "Sub_Dept_Name";
  isDesc: boolean = false;

  currentUser: User = new User();
  departmentMaster: DepartmentModel[] = [];
  departmentToBeEdited = new DepartmentModel();
  departmentSelected = new DepartmentModel();
  departmentToBeAdded = new DepartmentModel();
  duplicateRecordMessge: string = '';

  openQueries = [];

  isVisible = false;
  isConfirmLoading = false;
  departmentForm!: FormGroup; // Reactive form instance
  isEditMode = false; // Determines if the form is in edit mode

  constructor(
    private router: Router,
    //private toastrService: ToastrService,
    private userService: UserService,
    private adminService: AdminService,
    private fb: FormBuilder,
    private dbMasterService: DbMasterService,
    private messageService: NzMessageService,
    private modalService: NzModalService,
  ) { }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.currentUser.IsRFCAdmin) {
      this.getAllDepartments();
    }
    else {
      this.router.navigate(['/unauthorize']);
    }
    this.InitializeDepartmentForm(); // Initialize the form
  }
  InitializeDepartmentForm() {
    // Initialize the reactive form
    this.departmentForm = this.fb.group({
      departmentName: [
        '', // Default value
        [
          Validators.required, // Mandatory field
          Validators.maxLength(50), // Max character limit
          Validators.pattern('[a-zA-Z \\-,_&()/]*') // Pattern validation
        ]
      ]
    });
  }
  getAllDepartments() {
    this.adminService.getAllDepartments().subscribe((response: any) => {
      this.departmentMaster = response.output as DepartmentModel[];
    });
  }
  resetToDefault() {
    this.departmentSelected = this.departmentToBeEdited = this.departmentToBeAdded = new DepartmentModel();
    this.duplicateRecordMessge = "";
  }



  // Show the modal for creating a new department
  showCreateModal(): void {    
    this.isEditMode = false; // Set to create mode
    this.departmentForm.reset(); // Clear the form
    this.isVisible = true; // Show the modal
  }

  // Show the modal for editing an existing department
  showEditModal(department: DepartmentModel): void {
    this.isEditMode = true; // Set to edit mode    
    this.departmentToBeEdited = Object.assign({}, department); // Create a copy of the department object
    this.departmentForm.patchValue({
      departmentName: department.Department_Name // Populate the form with existing data
    });
    this.isVisible = true; // Show the modal
  }

  showDeactivateModal(department: DepartmentModel): void {  
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzContent: 'Are you sure, you want to <strong>deactivate </strong> the department - <span class="referanceNumber"> '+department.Department_Name +'</span>?',
      nzOkText: 'Yes',
      nzWidth: '500px',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzClosable: false,
      nzAutofocus: null,
      nzOnOk: () => this.deactivateDepartment(department),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }

  handleOk(): void {
    if (this.departmentForm.valid) {
      this.isConfirmLoading = true; // Show loading spinner
      const departmentName = this.departmentForm.value.departmentName;

      if (this.isEditMode) {
        // Update logic        
        // Call update API here
        this.departmentToBeEdited.Department_Name = departmentName; // Set the department name
        this.updateDepartment(); // Call the updateDepartment method to update the department
      } else {
        // Create logic        
        // Call create API here
        this.departmentToBeAdded.Department_Name = departmentName; // Set the department name
        this.addDepartment(); // Call the addDepartment method to add a new department
      }
      this.isConfirmLoading = false; // Hide loading spinner
    }
  }

  handleCancel(): void {
    this.isVisible = false;
    this.resetToDefault(); // Reset the form and messages
    this.isEditMode = false; // Reset to create mode
  }

  addDepartment() {
    var record = this.departmentMaster.filter(s => s.Department_Name.toLowerCase().trim() == this.departmentToBeAdded.Department_Name.toLowerCase().trim());
    if (record.length > 0) {
      this.duplicateRecordMessge = 'Department Name already exist';
    }
    else {
      this.departmentToBeAdded.Created_By = this.currentUser.User_Code ?? 0;
      this.adminService.addDepartment(this.departmentToBeAdded).subscribe((response: any) => {
        if (response.result) {
          
          this.getAllDepartments();
          this.messageService.success(`Department ${this.departmentToBeAdded.Department_Name} created successfully!`, { nzDuration: 3000 });
          this.resetModalPopup(); // Reset the form and messages
        }
        else {
          this.messageService.error("Department Name already exist."); 
        }
      });
      this.resetToDefault();
    }
  }
  updateDepartment() {
    var record = this.departmentMaster.filter(s => s.Department_Name.toLowerCase().trim() == this.departmentToBeEdited.Department_Name.toLowerCase().trim() 
                                        && s.Department_Code != this.departmentToBeEdited.Department_Code);    
    if (record.length > 0) {
      this.duplicateRecordMessge = 'Department Name already exist.';
    }
    else {      
      this.departmentToBeEdited.Created_By = this.currentUser.User_Code ?? 0;
      this.adminService.updateDepartment(this.departmentToBeEdited).subscribe((response: any) => {
        if (response.result) {
          //this.toastrService.success("Department updated Successfully!", 'Notification');
          this.getAllDepartments();
          this.messageService.success(`Department updated successfully!`, { nzDuration: Constants.SHOW_MESSAGE_DURATION });
          this.resetModalPopup(); // Reset the form and messages
        }
        else {
          //this.toastrService.error("Only active Department can be edited.", 'Notification');
        }
      });
      this.resetToDefault();
    }
  }
  deactivateDepartment(department: DepartmentModel) {
    if(department == null) {
      throw new Error('Department is null or undefined');
    }
    if(department.Department_Code == null) {
      throw new Error('Department code is null or undefined');
    }
    this.dbMasterService.GetActiveQueryReferenceNumber(DeactivateTypeEnum.Department,department.Department_Code).subscribe((response: any) => {
      if (response.output.length == 0) {
          let selectedDepartment = new DepartmentModel();
          selectedDepartment.Department_Code = department.Department_Code;
          selectedDepartment.Created_By = this.currentUser.User_Code??0;
          this.adminService.deleteDepartment(selectedDepartment).subscribe((response: any) => {
            if (response.result) {
              this.messageService.success(`Department deactivated successfully!`, { nzDuration: Constants.SHOW_MESSAGE_DURATION });
              this.getAllDepartments();
            }
            else{
              this.messageService.error("Only active Department can be deactivated.");
            }
            this.resetToDefault();
          });
      }
      else
      {
        this.openQueries = response.output as [];
        this.viewValidationMsg();
      }
    });  
  }
  viewValidationMsg() {    
    this.modalService.create({
          nzTitle: 'Validations',
          nzClosable: false,
          nzFooter: null,
          nzAutofocus: null,
          nzContent: ViewValidationsComponent,
          nzData: { 
                    validationText: 'Please respond to the open queries and then only deactivate <b>Department</b>.', 
                    openQueries: this.openQueries 
                  },
        });
  }

  resetModalPopup() {
    this.resetToDefault(); // Reset the form and messages
    this.isVisible = false; // Hide the modal
    this.isEditMode = false; // Reset to create mode
    this.isConfirmLoading = false; // Hide loading spinner
  }
}
